<template>
  <div>
    <div>
      <v-card v-if="serviorStatus==true">
        <v-card-title class="secondary">
          <span class="subtitle white--text">Assign Surveyor</span>
          <v-spacer></v-spacer>
          <v-icon class="white--text" @click="orgDialoge()">mdi-close</v-icon>
        </v-card-title>
        <v-container>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="9"></v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  class="pt-0"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-list dense v-if="user=='failed'">
              <v-list-item>
                <v-list-item-content>No Data Available</v-list-item-content>
              </v-list-item>
            </v-list>
            <v-data-table
              :headers="headers"
              :search="search"
              :items="user"
              item-key="name"
              class="elevation-2"
              :items-per-page="10"
              dense
            >
              <template v-slot:item.select="{ item }">
                <v-btn color="primary" x-small @click="createPacks(item)">Select</v-btn>
              </template>
              <template v-slot:item.serveyorname="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span class="caption text_ellipsis" v-on="on">{{ item.serveyorname}}</span>
                  </template>
                  <span>{{ item.serveyorname }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-container>
      </v-card>
    </div>
    <div>
      <v-card v-if="serviorStatus==false" dense>
        <v-container>
          <div style="font-size:20px" class="font-weight-black">Surveyor Name:{{ serviorName }}</div>

          <v-textarea
            color="teal"
            v-model="serveyorNotes"
            :counter="4000"
            :maxlength="max"
            label="Surveyor Notes"
          ></v-textarea>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="onclickback()">Back</v-btn>
            <v-btn
              color="primary accent-4"
              :loading="loading"
              :disabled="loading"
              @click="assignSurveryorToSurvey()"
            >Submit</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </div>
    <div>
      <v-snackbar
        v-model="alertPositive"
        color="secondary"
        :timeout="timeout"
        bottom="bottom"
      >{{ text }}</v-snackbar>
      <v-snackbar
        v-model="alertNegetive"
        color="primary"
        :timeout="timeout"
        bottom="bottom"
      >{{ text }}</v-snackbar>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["user", "serveId"],
  created: function() {
    console.log(this.user);
  },
  data() {
    return {
      text: "",
      search: "",
      loading: false,
      max: 4000,
      alertPositive: false,
      alertNegetive: false,
      timeout: 1700,
      itemsAraayOfsurveyid: [],
      serveyorNotes: "",
      serviorName: "",
      serviorStatus: true,
      headers: [
        {
          text: "Select",
          value: "select"
        },
        {
          text: "Surveyor Name",
          value: "serveyorname"
        },
        { text: "Surveyor Email", value: "serveyoremail" },
        { text: "Assigned Survey", value: "assigned_survey" },
        { text: "Pending Survey", value: "pending_survey" },
        { text: "Rejected Survey", value: "rejected_survey" },
        { text: "Completed Survey", value: "completed_survey" }
      ]
    };
  },
  methods: {
    orgDialoge() {
      this.$emit("backEdit");
    },
    onclickback() {
      this.serviorStatus = true;
    },
    createPacks(item) {
      this.itemsAraayOfsurveyid = item;
      this.serviorName = item.serveyorname;
      this.serviorStatus = false;
    },
    async assignSurveryorToSurvey() {
      this.loading = true;
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "AssignSurveryer_assignSurveryorToSurvey",
        input: {
          surveynotes: this.serveyorNotes,
          surveyid: this.serveId,
          orgid: this.itemsAraayOfsurveyid.orgid,
          surveyorid: this.itemsAraayOfsurveyid.surveyorid
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        var assignSurvery = res.data.data.data;
        if (assignSurvery == "Success") {
          this.text = "Assigned Succesfully";
          this.alertPositive = true;
          this.serveyorNotes = "";
          this.serviorStatus = true;
          var row = {
            surveyid: this.serveId,
            logCmd: "survey_assigned",
            surveyorid: this.itemsAraayOfsurveyid.surveyorid
          };
          console.log(row);
          this.$emit("backEdit", row);
          this.$emit("alertSuccess", this.text);
          this.loading = false;
        } else {
          this.text = "Error";
          this.alertNegetive = true;
          this.serveyorNotes = "";
          this.serviorStatus = true;
          this.$emit("backEdit");
          this.loading = false;
        }
      } catch (error) {
        return error.response;
      }
    }
  }
};
</script>

<style scoped>
.text_ellipsis {
  white-space: nowrap;
  max-width: 5vw;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
</style>